export { default as NewLogin } from "./Authentication/Form/Login/ClientLogin";


// Form Components - Formularios específicos (Server Components)
export { default as EditPassword } from "./Authentication/Form/EditPassword/Components/EditPassword";
export { default as ResetPasswordForm } from "./Authentication/Form/ResetPassword/Components/ResetPassword";
// export { default as MisDatosForm } from "./Forms/MisDatos/MisDatosForm";

// Form Wrappers - Componentes cliente con validaciones
export { default as EditPasswordWrapper } from "./Authentication/Form/EditPassword/ClientEditPassword";
export { default as ResetPasswordWrapper } from "./Authentication/Form/ResetPassword/ClientResetPassword";
